import { render, staticRenderFns } from "./JudgeInputModal.vue?vue&type=template&id=3a095330&scoped=true"
import script from "./JudgeInputModal.vue?vue&type=script&lang=js"
export * from "./JudgeInputModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a095330",
  null
  
)

export default component.exports